import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const CampaignListener = () => {
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const campaign = params.get('campaign');
    if (campaign) {
      // Store the campaign code for use during profile creation
      localStorage.setItem('campaign_code', campaign);
    }
  }, [location]);

  return null;
};
